import { useMutation, useQuery } from "@apollo/client";
import { CewpUserView } from "components/cards";
import { Modal } from "components/layouts";
import { FC } from "react";
import toast from "react-hot-toast";
import { useSearch } from "react-location";
import { LocationGenerics } from "router/location";
import { withRoles, wrapClick } from "utils";
import { GET_CEWP_USER, SUSPEND_CEWP_USER } from "./apollo";

interface SuspendCewpUserContainerProps {
  open: boolean;
  setOpen: (val: boolean) => void;
  refetch?: () => void;
}

const SuspendCewpUserContainer: FC<SuspendCewpUserContainerProps> = ({
  open,
  setOpen,
  refetch,
}) => {
  const searchParams = useSearch<LocationGenerics>();
  const { data, loading } = useQuery(GET_CEWP_USER, {
    variables: {
      id: searchParams.id,
    },
    skip: !searchParams.id,
    notifyOnNetworkStatusChange: false,
  });

  const [suspendCEWPUser, { loading: loadingSuspend }] = useMutation(
    SUSPEND_CEWP_USER,
  );

  const suspendItem = async () => {
    await suspendCEWPUser({
      variables: {
        id: searchParams.id,
      },
    }).then(({ data: result }) => {
      if (result?.suspendCEWPUser?._id) {
        toast(
          JSON.stringify({
            type: "success",
            title: "CEWP User Suspended Successfully",
          }),
        );
        refetch?.();
        setOpen(false);
      } else {
        toast(
          JSON.stringify({
            type: "error",
            title: "Could not suspend CEWP user",
          }),
        );
      }
    });
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading}
      title="Suspend CEWP User"
      description="Are you sure you want to suspend this CEWP user?"
      renderActions={() => (
        <>
          {withRoles(["Super"])(
            <button
              type="button"
              disabled={loadingSuspend}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-primary-600 text-base font-medium text-white hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 sm:ml-3 sm:w-auto sm:text-sm"
              onClick={wrapClick(suspendItem)}
            >
              {loadingSuspend ? "Suspending..." : "Suspend User"}
            </button>,
          )}
        </>
      )}
    >
      {data?.user?._id && <CewpUserView user={data.user} />}
    </Modal>
  );
};

export default SuspendCewpUserContainer;
